import Head from './../components/Head';
import Footer from './../components/Footer';
import MoocCourse from './components/mooc/Course.vue';
import ResourceCenter from './components/ResourceCenter.vue';
import SpocCourse from './components/SpocCourse.vue';
import TeacherList from './components/TeacherList';
import BannerList from './components/BannerList';
import News from './components/HomeNews.vue';
import NewsTwo from './components/HomeNewsTwo.vue';
import TeacherData from './components/TeachData.vue';
import DataDisplay from './components/DataDisplay.vue';
import Link from '../components/aboutLink.vue';
import TeachingCenterList from './components/TeachingCenterList.vue';
import FloatContainer from '@/pages/components/FloatContainer';
import Lecture from './components/Lecture/index.vue';
import UserCard from './components/UserCard/index.vue';
import TrainingProgram from './components/TrainingProgram/index.vue';
import { Empty } from 'zhs-components';
import Workspace from './components/Workspace.vue';
export default {
  components: {
    Head,
    MoocCourse,
    TeacherList,
    BannerList,
    News,
    NewsTwo,
    Footer,
    SpocCourse,
    TeacherData,
    Link,
    ResourceCenter,
    TeachingCenterList,
    DataDisplay,
    FloatContainer,
    Lecture,
    UserCard,
    TrainingProgram,
    Empty,
    Workspace
  },

  provide() {
    return {
      uuid: () => this.uuid,
      userId: () => this.userId
    };
  },

  created() {
    this.getDataList();
  },

  data() {
    return {
      menuCode: '10301',
      dataList: [],
      liveList: [],
      footerItem: null,
      dataItem: null,
      bannerItem: null,
      moocItem: null,
      spocItem: null,
      // newsItem: null,
      newsItemArr: [],
      teacherItem: null,
      teachingCenterItem: null,
      menuInfo: {},
      userInfo: null,
      zhsRole: 0,
      uuid: '',
      userId: '',
      newsWidth: '1200px',
      newsHalfWidth: '600px',
      lectureItem: null,
      sortItem: null,
      // 排序模块
      sortMenuCode: ['10401', '10402', '17100'] // 排序模块 spoc mooc 培训项目

    };
  },

  methods: {
    async getDataList() {
      const res = await this.$http.getDataList();
      console.log('首页数据', res);
      this.dataList = res || [];
      this.footerItem = this.dataList.find(item => item.function_id == '10303');
      this.dataItem = this.dataList.find(item => item.function_id == '10304');
      this.dataItem.backImage = "https://prod-polymas.oss-cn-hangzhou.aliyuncs.com/polymas-basic-resource/YkX3ld/JaCT4n/693a300ce4b0824e3e4a6159.png";
      this.bannerItem = res.find(item => item.function_id == '10302');
      this.moocItem = res.find(item => item.function_id == '10401');
      this.spocItem = res.find(item => item.function_id == '10402');
      this.newsItemArr = res.filter(item => item.function_id == '10701' && item.home_open === 1);
      console.log('this.newsItemArr', this.newsItemArr);
      this.teacherItem = res.find(item => item.function_id == '10501');
      this.teachingCenterItem = res.find(item => item.function_id == '51001');
      this.lectureItem = this.dataList.filter(item => item.function_id == '40005' && item.home_open == 1);
      this.sortItem = this.dataList.filter(item => this.sortMenuCode.includes(item.function_id) && item.home_open == 1);
      console.log('sortItem', this.sortItem);
      this.$nextTick(() => {
        this.initColor();
      });
    },

    //初始化背景色
    initColor() {
      // this.sortItem[0].backColor = '#f00'
      // this.sortItem[0].backImage = 'https://image.zhihuishu.com/zhs/b2cm/base1/202208/de16a466212245c49fee7978f78690bd.png'
      // this.sortItem[1].backColor = 'pink'
      // this.sortItem[2].backColor = 'black'
      // this.sortItem[3].backColor = 'pink'
      // this.sortItem[4].backColor = 'green'
      // this.teachingCenterItem.backColor = 'pink'
      // this.newsItemArr[0].backColor = 'green'
      //sortItem背景
      this.sortItem.forEach((item, i) => {
        this.setColor(item, `.second-module-wrapper${i}`);
      }); //教案中心

      if (this.teachingCenterItem && this.teachingCenterItem.backColor) this.setColor(this.teachingCenterItem, `.teachingcenter-warp`); //新闻

      this.newsItemArr.forEach((item, i) => {
        if (i > 0) {
          this.setColor(item, `.news-box`);
        } else {
          this.setColor(item, '.first-module-wrapper');
        }
      });
      if (this.footerItem) this.setColor(this.footerItem, `.footer-box`);
    },

    setColor(data, className) {
      //背景图
      if (data.backImage) {
        let dom = document.querySelector(className);

        if (dom) {
          dom.style.background = `url(${data.backImage}) no-repeat`;
          dom.style.backgroundSize = 'cover';
        }

        return;
      } //背景色


      if (data.backColor) {
        let dom = document.querySelector(className);
        if (dom) dom.style.background = data.backColor;
      }
    },

    getUserInfo(data) {
      this.userInfo = data;
      this.uuid = data.uuid;
      this.userId = data.id;
    },

    getZhsRole(data) {
      this.zhsRole = data || 0; // this.zhsRole = 1
    }

  }
};